<script>

import NavBar from './NavBar.vue';
import LeftNavMenu from './LeftNavMenu.vue';
import CampaignUsbResultsComponent from './CampaignUsbResultsComponent';

    export default {
    name: 'CampaignUsbResultsPage',
    props: { titolo: String },
    //components: { NavBar, LeftNavMenu,LoginComponent }
    components: { NavBar, LeftNavMenu, CampaignUsbResultsComponent }
}
</script>

<template lang="html">

        <body>
            <NavBar />
           <LeftNavMenu />
            <CampaignUsbResultsComponent /> 
        </body>   
   
</template>
  
<style lang="css">

</style>